import {
  Box,
  FormControlLabel,
  Radio,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

interface CreateCfsMethodSettingsProps {
  createCfsMethod: string;
  onMethodChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CreateCfsMethodSettings = ({
  createCfsMethod,
  onMethodChange,
}: CreateCfsMethodSettingsProps) => {
  const theme = useTheme();

  const handleBoxClick = (value: string) => {
    const event = {
      target: { value },
    } as React.ChangeEvent<HTMLInputElement>;
    onMethodChange(event);
  };

  return (
    <Box
      sx={{
        border: 0,
        p: 1,
        height: '100%',
      }}
    >
      <Typography variant="body2" sx={{ mb: 1 }}>
        When clicking on a CFS it should open in:
      </Typography>
      <Stack
        flex={1}
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="start"
        spacing={0}
      >
        <Stack direction="column" sx={{ width: '100%', maxWidth: 400 }}>
          <Box
            sx={{
              px: 2,
              py: 1,
              border: 1,
              borderColor: 'divider',
              borderRadius: '4px 4px 0 0',
              borderBottom: 0,
              minHeight: 64,
              display: 'flex',
              alignItems: 'center',
              backgroundColor:
                createCfsMethod === 'new-window'
                  ? theme.palette.action.selected
                  : 'transparent',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor:
                  createCfsMethod === 'new-window'
                    ? theme.palette.action.selected
                    : theme.palette.action.hover,
              },
            }}
            onClick={() => handleBoxClick('new-window')}
          >
            <FormControlLabel
              control={
                <Radio
                  checked={createCfsMethod === 'new-window'}
                  onChange={onMethodChange}
                  value="new-window"
                  name="create-cfs-method"
                  color="error"
                />
              }
              label={<Typography variant="body2">In a new tab</Typography>}
              sx={{ margin: 0, pointerEvents: 'none' }}
            />
          </Box>
          <Box
            sx={{
              px: 2,
              py: 1,
              border: 1,
              borderColor: 'divider',
              borderRadius: '0 0 4px 4px',
              minHeight: 64,
              display: 'flex',
              alignItems: 'center',
              backgroundColor:
                createCfsMethod === 'slide-view'
                  ? theme.palette.action.selected
                  : 'transparent',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor:
                  createCfsMethod === 'slide-view'
                    ? theme.palette.action.selected
                    : theme.palette.action.hover,
              },
            }}
            onClick={() => handleBoxClick('slide-view')}
          >
            <FormControlLabel
              control={
                <Radio
                  checked={createCfsMethod === 'slide-view'}
                  onChange={onMethodChange}
                  value="slide-view"
                  name="create-cfs-method"
                  color="error"
                />
              }
              label={<Typography variant="body2">In full page view</Typography>}
              sx={{ margin: 0, pointerEvents: 'none' }}
            />
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};
